import { helper } from "lib/helper";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Container,
  Row,
  Table,
  Input,
  FormGroup,
  Col,
  Label, // Import Input for search
} from "reactstrap";
// core components
import TablePagination from "views/components/TablePagination";
import img from "../../assets/img/brand/goodybuddy_short.png";
import { filterItems } from "lib/helper"; // Import the filtering function
import * as XLSX from "xlsx"; // Import XLSX for exporting to Excel
import ExportButton from "components/ExportButton";
import adminModel from "models/admin.model";
import noImage from "../../assets/img/noImage.png";
import Loader from "components/loader/Loader";


const AllSubCategory = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [categoriesList, setCategoriesList] = useState([]);
  const [experienceList, setexperienceList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [expid, setexpid] = useState("67a1dfdb6bebae0d2d2fa867");



  const navigate = useNavigate();

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const fetchExperienceCategory = async () => {
    setIsLoading(true);

    try {
      const res = await adminModel.getExperienceCategory();
      setexperienceList(res.data);
      setexpid(res.data[4]._id);
      const response = await adminModel.getAllSubCategories(expid);
     
      const transformedData = [];

      const getShowName = (key) => {

        switch (key) {
          case "coreActivitiesOptions":
            return "Core Activities";
          case "goodsOrServiceOptions":
            return "Experience Goods or Service";
          case "intendedAudienceOptions":
            return "Intended Audience";
          case "experienceEntryOptions":
            return "Experience Entry";
          case "experienceExitOptions":
            return "Experience Exit";
          case "experienceCommitmentOptions":
            return "Experience Commitment";
          case "experienceGiftOptions":
            return "Experience Gift";
          default:
            return key;
        }
      };

      for (const [key, values] of Object.entries(response.options)) {
        if (Array.isArray(values)) {
          values.forEach((value, index) => {

            if (typeof value === "object" && value !== null) {
              transformedData.push({
                key: key,
                show: getShowName(key),
                identifier: value._id || `${key}`,
                value: value.name || JSON.stringify(value),
                image: value.image,
                imageKey: value.imageKey,
              });
            } else {
              transformedData.push({
                key: key,
                show: getShowName(key),
                identifier: `${key}`,
                value: value,
              });
            }
          });
        }
      }


      setCategoriesList(transformedData.reverse());
      setIsLoading(false);
    } catch (error) {
      console.log('fetchExperienceCategory---->', error);
      helper.sweetalert.toast(error.response?.data?.message, "warning");
      setIsLoading(false);
    }
  };
  const getNewCategoryOption = async () => {
    setIsLoading(true);
    try {
      const response = await adminModel.getAllSubCategories(expid);
      const transformedData = [];


      const getShowName = (key) => {

        switch (key) {
          case "coreActivitiesOptions":
            return "Core Activities";
          case "goodsOrServiceOptions":
            return "Experience Service";
          case "intendedAudienceOptions":
            return "Intended Audience";
          case "experienceEntryOptions":
            return "Experience Entry";
          case "experienceExitOptions":
            return "Experience Exit";
          case "experienceCommitmentOptions":
            return "Experience Commitment";
          case "experienceGiftOptions":
            return "Experience Gift";
          case "goods":
            return "Experience Goods"
          default:
            return key;
        }
      };

      for (const [key, values] of Object.entries(response.options)) {
        if (Array.isArray(values)) {
          values.forEach((value, index) => {
            if (typeof value === "object" && value !== null) {
              transformedData.push({
                key: key,
                show: getShowName(key),
                identifier: value._id || `${key}`,
                value: value.name || JSON.stringify(value),
                image: value.image,
                imageKey: value.imageKey,
              });
            } else {
              transformedData.push({
                key: key,
                show: getShowName(key),
                identifier: `${key}`,
                value: value,
              });
            }
          });
        }
      }
      setCategoriesList(transformedData.reverse());
      setIsLoading(false);
    } catch (error) {
      console.log('getNewCategoryOption---->', error);

      helper.sweetalert.toast(error.response?.data?.message, "warning");
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getNewCategoryOption();
  }, [expid]);

  const handleDelete = async (data) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this category?", "info", true)
      .then(async (result) => {
        if (result.isConfirmed) {
          setIsLoading(true);
          try {

            const response = await adminModel.deleteOption(data);
            console.log('on delete---->', { data, response });
            fetchExperienceCategory();         
            helper.sweetalert.toast("Category deleted successfully!");
            setIsLoading(false);
          } catch (error) {
            console.log('delete error ---->', error);

            setIsLoading(false);
            helper.sweetalert.toast(
              error.response?.data?.message || "Something went wrong",
              "warning"
            );
          }
        }
      });
  };

  // Filter categories based on the search query
  //   const filteredCategoriesList = filterItems(categoriesList, searchQuery, ['show' , 'value' , 'key']);

  const getFilteredData = (data, query, keys) => {
    const res = data.filter((item) => {
      return keys.some((key) => {
        const value = key.split(".").reduce((acc, part) => acc?.[part], item);
        let returnVal = value?.toString().toLowerCase().includes(query.toLowerCase());
        return returnVal;
      });
    });
    return res;
  };


  const filteredCategoriesList = getFilteredData(categoriesList, searchQuery, ["show", "value", "key"]);

  const columnsConfig = [
    {
      label: "S.No",
      getValue: (item, index, currentPage, perPage) =>
        (currentPage - 1) * perPage + index + 1,
    },
    {
      label: "Category Type",
      getValue: (item) => item?.show,
    },
    {
      label: "Option Name",
      getValue: (item) => item.value,
    },
  ];
console.log("tttt",categoriesList)

  useEffect(() => {
    fetchExperienceCategory();
  }, [setexpid]);

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <Container className="pt-6">
        {!isLoading && (
          <Row>
            <div className="col pl-0 pr-0 mr-3">
              <Card className="shadow">
                <CardHeader className="border-0  d-flex justify-content-between align-items-center">
                  <h3 className="mb-0">All Tags</h3>
                  <div className="d-flex align-items-center">
                    <div>
                      <Col md="12" mr>
                        <FormGroup>
                          <Label className="text-xs" for="type">
                            Experience Tags
                          </Label>
                          <Input
                            type="select"
                            name="type"
                            id="type"
                            value={expid}
                            onLoad={(e) => setexpid(e.target.value)}
                            onChange={(e) => {
                              setexpid(e.target.value);

                            }}
                            required
                          >
                            {experienceList.map((e, i) => {
                              return (
                                <option key={i} value={e._id}>
                                  {e.name}
                                </option>
                              );
                            })}
                          </Input>
                        </FormGroup>
                      </Col>
                    </div>
                    <Input
                      type="text"
                      placeholder="Search by Category Type , Name..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{ width: "300px", marginRight: "10px" }} // Optional: adjust width
                    />
                    <ExportButton
                      data={filteredCategoriesList}
                      columnsConfig={columnsConfig}
                    />
                  </div>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">S.No</th>
                      <th scope="col">Tags Type</th>
                      <th scope="col">Option Name</th>
                      <th scope="col">Icon / Image</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredCategoriesList

                      .slice((currentPage - 1) * perPage, currentPage * perPage)
                      .map((item, index) => {

                        return (
                          <tr key={item._id}>
                            <td className="px-4 py-1">{(currentPage - 1) * perPage + index + 1}</td>
                            <td className="px-4 py-1">{item?.show}</td>
                            <td className="px-4 py-1">{item?.value}</td>{" "}
                            {/* Display numeric priority */}
                            <td className="px-4 py-1">
                              <img
                                src={item?.image || noImage}
                                alt={item?.name}
                                style={{ width: "40px", height: "40px" }}
                              />
                            </td>
                            <td className="px-4 py-1">
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => handleDelete(item)}
                              >
                                <i class="fa-solid fa-trash"></i>
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
                <CardFooter className="py-4">
                  <TablePagination
                    totalPages={Math.ceil(
                      filteredCategoriesList.length / perPage
                    )}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    pageUrl="/admin/categories?"
                  />
                </CardFooter>
              </Card>
            </div>
          </Row>
        )}
      </Container>
    </>
  );
};

export default AllSubCategory;
